console.log("slick-slider.js");
import $ from 'jquery';

class slickSlider {
	constructor() {
		this.slider = $(".swiper-wrapper");
		this.initCarousel();
	}

	initCarousel() {
		this.slider.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			infinite: false,
			speed: 500,
			slidesToShow: 2,
			slidesToScroll: 2,
			adaptiveHeight: true,
			//centerMode: false,
			centerPadding: '2em',
			fade: false,
			mobileFirst: true,
			arrows: false,
			responsive: [{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}, {
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
				}
			}]
		});
	}
}

export default slickSlider;